import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClimeTransferModalUI from './ClimeTransferModalUI.js'

class ClimeTransferModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      bankAccountNum: this.props.loanBankAccountNum,
      bankAccountNumError: null,
      amount: '',
      amountError: null,
      //
      narration: '',
      narrationError: null,

    }
  }

  render() {
    let bankAccountNumList = [
      {key: this.props.loanBankAccountNum, value: this.props.loanBankAccountNum},
      {key: this.props.genBankAccountNum, value: this.props.genBankAccountNum},
    ]

    return (
      <ClimeTransferModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        transferMode={this.props.transferMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        bankAccountNum={this.state.bankAccountNum}
        onBankAccountNumChange={(event) => { this.setState({ bankAccountNum: event.target.value }) }}
        bankAccountNumError={this.state.bankAccountNumError}
        setBankAccountNumError={(error) => { this.setState({ bankAccountNumError: error }) }}
        bankAccountNumList={bankAccountNumList}
        amount={this.state.amount}
        onAmountChange={(event) => { this.setState({ amount: event.target.value }) }}
        amountError={this.state.amountError}
        setAmountError={(error) => { this.setState({ amountError: error }) }}
        //
        narration={this.state.narration}
        onNarrationChange={(event) => { this.setState({ narration: event.target.value }) }}
        narrationError={this.state.narrationError}
        setNarrationError={(error) => { this.setState({ narrationError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    // Client-side validation
    let hasErrors = false
    const newErrorsObj = {}
    const newErrorsList = []

    if (!this.state.amount) {
      newErrorsObj.amountError = 'Amount is required'
      newErrorsList.push('Amount is required')
      hasErrors = true
    }

    if (hasErrors) {
      this.setState({
        ...newErrorsObj,
        errorList: newErrorsList
      })
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/bankAccounts/${this.state.bankAccountNum}/transfers/clime`,
      this.onSubmitCallback, {
        amountF: this.state.amount,
        narration: this.state.narration,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(ClimeTransferModalSF)
